import { Navigate, Outlet } from "react-router";

import { useSession } from "./useSession";

/**
 * Keeps a signed-in clinician off /signin.
 *
 * Renders the form immediately, INCLUDING while the bootstrap refresh is still
 * in flight. The refresh cookie is httpOnly, so the only way to learn whether a
 * session exists is to ask the API — and making the common visitor here (a
 * signed-out one) watch a splash for the length of that round trip, to be told
 * what they already knew, is the wrong trade. An already-signed-in visitor is
 * rare and merely sees the form for a beat before the redirect fires.
 */
export function RedirectIfAuthenticated() {
  const { status } = useSession();
  if (status === "authenticated") return <Navigate to="/" replace />;
  return <Outlet />;
}
